import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserSettingsService } from '../service/user-settings.service';
import * as UserSettingsActions from './user-settings.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class UserSettingsEffects {
  private actions$ = inject(Actions);
  private userSettingsService = inject(UserSettingsService);

  getUserSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSettingsActions.loadUserSettings),
      switchMap(() => {
        return this.userSettingsService.getUserSettings().pipe(
          map((_response) =>
            UserSettingsActions.loadUserSettingsSuccess({ userSettings: { settings: _response.settings } })
          ),
          catchError((error) => of(UserSettingsActions.loadUserSettingsFailure({ error })))
        );
      })
    )
  );

  setUserSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSettingsActions.setUserSettings),
      switchMap(({ key, value }) =>
        this.userSettingsService.setUserSettingsForKey(key, value).pipe(
          map((response) => UserSettingsActions.setUserSettingsSuccess({ response: { ...response, key } })),
          catchError((error) => of(UserSettingsActions.setUserSettingsFailure({ error: { ...error, key } })))
        )
      )
    )
  );

  deleteUserSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSettingsActions.deleteUserSettings),
      switchMap(({ key }) =>
        this.userSettingsService.deleteUserSettingsForKey(key).pipe(
          map((response) => UserSettingsActions.deleteUserSettingsSuccess({ response: { ...response, key } })),
          catchError((error) => of(UserSettingsActions.deleteUserSettingsFailure({ error: { ...error, key } })))
        )
      )
    )
  );
}
